import { normalizeText } from '../../helpers'
import type { BillSummary } from '../../models'

const SUBJECT_TYPEAHEAD_LIMIT = 20

// uniqueSubjects collects all subjects from bills, deduplicating by normalized
// text (accent-insensitive). Preserves the original casing of the first
// occurrence for each normalized key, ordered by normalized key (BTreeMap
// order from Rust).
export function uniqueSubjects(bills: BillSummary[]): string[] {
  const map = new Map<string, string>()
  for (const bill of bills) {
    for (const subject of bill.subjects) {
      const key = normalizeText(subject)
      if (!map.has(key)) {
        map.set(key, subject)
      }
    }
  }
  // BTreeMap in Rust iterates in sorted key order
  const sortedKeys = [...map.keys()].sort()
  return sortedKeys.map((k) => map.get(k) ?? k)
}

// subjectSuggestions returns up to SUBJECT_TYPEAHEAD_LIMIT subjects whose
// normalized text contains the normalized query. Returns empty array for empty
// queries (matches Rust behavior).
export function subjectSuggestions(subjects: string[], query: string): string[] {
  const normalized = normalizeText(query)
  if (normalized === '') return []
  return subjects
    .filter((s) => normalizeText(s).includes(normalized))
    .slice(0, SUBJECT_TYPEAHEAD_LIMIT)
}
